import React from "react";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import MainPage from "../MainPage/MainPage";
import SearchPage from "../SearchPage/SearchPage";
import { Provider } from "react-redux";
import { store } from "../../redux/store";
import { StatCounter } from "../StatCounter";
import { GoogleAnalytics } from "../GoogleAnalytics";
import MyNavbar from "../Navbar/Navbar";
import LoadingBar from "react-redux-loading";
import { Container, Row } from "react-bootstrap";
import AboutPage from "../About/AboutPage";
import Page404 from "./Page404";
class BooksApp extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <GoogleAnalytics />
        <StatCounter />
        <Container>
          <Row>
            <div className="fixed-top">
              <MyNavbar />
            </div>
            <div className="fixed-top">
              <LoadingBar />
            </div>
          </Row>
          <Row>
            <div className="container">
              <Switch>
                <Route exact path="/search" component={SearchPage} />
                <Route exact path="/" component={MainPage} />
                <Route exact path="/about" component={AboutPage} />
                <Route render={() => <Page404 />} />
              </Switch>
            </div>
          </Row>
        </Container>
      </Provider>
    );
  }
}

export default BooksApp;
